import { render, staticRenderFns } from "./quest.vue?vue&type=template&id=67c5ec22&"
import script from "./quest.vue?vue&type=script&lang=ts&"
export * from "./quest.vue?vue&type=script&lang=ts&"
import style0 from "./quest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports